import quickchen_0 from "../../images/projects/quickchen/0.PNG";
import quickchen_1 from "../../images/projects/quickchen/1.PNG";
import quickchen_2 from "../../images/projects/quickchen/2.PNG";
import quickchen_3 from "../../images/projects/quickchen/3.PNG";
import quickchen_4 from "../../images/projects/quickchen/4.PNG";
import quickchen_5 from "../../images/projects/quickchen/5.PNG";
import quickchen_6 from "../../images/projects/quickchen/6.PNG";
import quickchen_7 from "../../images/projects/quickchen/7.PNG";
import quickchen_8 from "../../images/projects/quickchen/8.PNG";

export default function quickchenImages() {
  return [
    quickchen_0,
    quickchen_1,
    quickchen_2,
    quickchen_3,
    quickchen_4,
    quickchen_5,
    quickchen_6,
    quickchen_7,
    quickchen_8,
  ];
}
